export default __webpack_public_path__ + "static/media/left-background.b91a0065.png";